<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">{{this.title}}</h2>
      <div class="modal-subtitle" *ngIf="this.data.lotName">{{"Lot" | tenantWords}} {{this.data.lotName}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="cancel()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">
    <section class="form-section" *ngIf="this.isTransfer">
      <div class="section-head">
        <fa-icon [icon]="faLocationDot" class="section-icon"></fa-icon>
        <h3>Destination</h3>
        <div class="section-actions">
          <button mat-stroked-button type="button" (click)="scan()">
            <fa-icon [icon]="faBarcode" class="me-2"></fa-icon>Scan Location
          </button>
        </div>
      </div>

      <div class="section-grid cols-3">
        <mat-form-field appearance="outline">
          <mat-label>{{"Warehouse" | tenantWords}}</mat-label>
          <mat-select id="warehouse" [(ngModel)]="this.lotInventoryObj.toWarehouseId" name="warehouse"
            (selectionChange)="this.warehouseSelectionChanged()">
            <mat-option *ngFor="let warehouse of this.warehouses" [value]="warehouse.id">
              {{warehouse.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{"Room" | tenantWords}}</mat-label>
          <mat-select id="room" [(ngModel)]="this.lotInventoryObj.toRoomId" name="room"
            (selectionChange)="this.roomSelectionChanged()">
            <mat-option *ngFor="let room of this.rooms" [value]="room.id">
              {{room.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{"Location" | tenantWords}}</mat-label>
          <mat-select id="location" [(ngModel)]="this.lotInventoryObj.toLocationId" name="location"
            (selectionChange)="this.locationSelectionChanged()">
            <mat-option *ngFor="let location of this.locations" [value]="location.id">
              {{location.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>

    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faHashtag" class="section-icon"></fa-icon>
        <h3>Details</h3>
      </div>

      <div class="section-grid cols-2">
        <mat-form-field appearance="outline">
          <mat-label>Quantity</mat-label>
          <input matInput type="number" min="0" id="quantityInput" name="quantityInput" required
            [(ngModel)]="this.lotInventoryObj.quantity">
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="this.isAddToOrder">
          <mat-label>Order Number</mat-label>
          <input matInput type="text" id="orderNumber" name="orderNumber" required
            [(ngModel)]="this.lotInventoryObj.orderNumber">
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="!this.isAddToOrder">
          <mat-label>{{"Reason" | tenantWords}}</mat-label>
          <mat-select id="reason" [(ngModel)]="this.lotInventoryObj.reasonCodeId" name="reason" required>
            <mat-option *ngFor="let re of this.reasonCodes" [value]="re.id">
              {{re.reason}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </section>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="!this.canSave" (click)="submit()">
      <fa-icon [icon]="faArrowRight" class="me-2"></fa-icon>{{this.isTransfer ? 'Move' : 'Save'}}
    </button>
  </div>

</div>
